/* React */
import React, { Component } from 'react';

/* Redux */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withRouter } from 'react-router-dom';
import { actions as ruleActions } from '../../redux/ducks/rule'

import { S } from '../../routes/routes';
import { SubViewHeaderStep } from '../../lib/components/subHeader';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';

import { SizeMe } from 'react-sizeme';
import { CustomTableCell } from '../../custom/table';
import { getWidthColumnByPercent } from '../../lib/components/function';

import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

import EditIcon from '@material-ui/icons/Edit';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import DeleteIcon from '@material-ui/icons/DeleteOutline';

import { safeDeepDel, safeDeepGetWithType, safeDeepGet } from 'iotera-base/json';
import { _N, isEmpty } from 'iotera-base/object';
import uuid from 'uuid';
import { keys } from '@material-ui/core/styles/createBreakpoints';

const uuidv1 = require('uuid/v1');

class RuleCreateTrigger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      optionOpen: false,
      currentTrigger: {},
      currentTriggerKey: null,
      currentField: null,
      currentOp: null,
      currentValue: null,
      currentValueType: 'string'
    }
    this.handleEdit = this.handleEdit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDialogTrigger = this.handleDialogTrigger.bind(this);
    this.handleSubmitDialogTrigger = this.handleSubmitDialogTrigger.bind(this);
    this.handleCancelDialogTrigger = this.handleCancelDialogTrigger.bind(this);
  }

  componentDidMount() {
    const _this = this
    const _props = _this.props
    const currentTrigger = safeDeepGetWithType(_props, ['trigger'], {});
    _this.setState({
      currentTrigger: { ...currentTrigger }
    });
  }

  handleEdit(key) {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { dialogOpen } = _state
    _this.setState({
      currentTriggerKey: key,
      dialogOpen: !dialogOpen
    });
    _this.handleDialogTrigger();
  }

  handleDelete(key) {
    const _this = this
    const _state = _this.state
    const { currentTrigger } = _state
    safeDeepDel(currentTrigger, [key]);
    _this.setState({
      currentTrigger: { ...currentTrigger }
    });
  }

  handleNext() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { currentTrigger } = _state
    _props.setCreateTrigger(currentTrigger)
    _props.history.push('.' + S + 'action');
  }

  handleBack() {
    this.props.history.replace('.' + S + 'info');
  }

  handleChange(event) {
    const _this = this
    const name = safeDeepGet(event, ['target', 'name'], '');
    const value = safeDeepGet(event, ['target', 'value'], '');
    if (name === 'field') {
      let cvt;
      if (value === 'VALUE') {
        cvt = 'number';
      } else {
        cvt = 'string';
      }
      _this.setState({
        currentValueType: cvt,
        currentField: value
      });
    } else if (name === 'op') {
      _this.setState({
        currentOp: value
      });
    } else if (name === 'value') {
      _this.setState({
        currentValue: value
      });
    }
  }

  handleDialogTrigger() {
    const _this = this
    const _state = _this.state
    const { dialogOpen } = _state
    _this.setState({
      dialogOpen: !dialogOpen
    });
  }

  handleSubmitDialogTrigger() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { currentTriggerKey, currentField, currentOp, currentValue, dialogOpen } = _state
    let { currentTrigger } = _state
    let key;
    if (currentTriggerKey == null) {
      key = uuid();
    } else {
      key = currentTriggerKey;
    }
    currentTrigger[key] = {
      "node_type": "INCOMING_DEVICE_DATA",
      "field": {
        "query": currentField
      },
      "op": currentOp,
      "value": currentValue
    }
    _this.setState({
      currentTrigger: { ...currentTrigger },
      currentTriggerKey: null,
      dialogOpen: !dialogOpen
    });
    _props.setCreateTrigger(_state.currentTrigger)
  }

  handleCancelDialogTrigger() {
    const _this = this
    const _state = _this.state
    const { dialogOpen } = _state
    _this.setState({
      currentTriggerKey: null,
      dialogOpen: !dialogOpen
    });
  }

  render() {
    // Check if info is empty
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const info = safeDeepGet(_props, ['info'], {});
    if (isEmpty(info)) {
      _props.history.push('.' + S + 'info');
    }
    const { currentTrigger, currentTriggerKey, currentValueType } = _state
    const currentTriggerSize = Object.keys(currentTrigger).length;
    const initField = safeDeepGet(currentTrigger, [currentTriggerKey, 'field', 'query'], '');
    const initOp = safeDeepGet(currentTrigger, [currentTriggerKey, 'op'], '');
    const initValue = safeDeepGet(currentTrigger, [currentTriggerKey, 'value'], '');
    return (
      <div className="view">
        <SubViewHeaderStep title='Tambah Rule'
          subTitle='Rule Trigger'
          steps={['Info', 'Trigger', 'Action']}
          activeStep={1} />
        <div className="io-container mt-12" >
          <SizeMe>{({ size }) =>
            <div>
              {currentTriggerSize > 0 && <div>
                <Table className="table">
                  <TableHead style={{ height: 0 }}>
                    <TableRow>
                      <CustomTableCell style={{
                        minWidth: getWidthColumnByPercent(30, size.width - 140),
                        maxWidth: getWidthColumnByPercent(35, size.width - 140)
                      }}>
                        Field
                      </CustomTableCell>
                      <CustomTableCell style={{
                        minWidth: getWidthColumnByPercent(20, size.width - 140),
                        maxWidth: getWidthColumnByPercent(30, size.width - 140)
                      }}>
                        op
                      </CustomTableCell>
                      <CustomTableCell style={{
                        minWidth: getWidthColumnByPercent(30, size.width - 140),
                        maxWidth: getWidthColumnByPercent(35, size.width - 140)
                      }}>
                        Value
                      </CustomTableCell>
                      <CustomTableCell style={{
                        minWidth: getWidthColumnByPercent(20, size.width - 140),
                        maxWidth: getWidthColumnByPercent(30, size.width - 140)
                      }}>
                      </CustomTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.keys(currentTrigger).map((key) =>
                      <TableRow key={key} className='table-row-child-iotera'>
                        <TableCell >
                          {currentTrigger[key]['field']['query']}
                        </TableCell>
                        <TableCell >
                          {currentTrigger[key]['op']}
                        </TableCell>
                        <TableCell >
                          {currentTrigger[key]['value']}
                        </TableCell>
                        <TableCell>
                          <UncontrolledDropdown onMouseOver={(e) => {
                            let optionOpen = safeDeepGetWithType(_state, ['optionOpen'], {});
                            optionOpen[key] = true;
                            _this.setState({ optionOpen: { ...optionOpen } });
                          }} onMouseLeave={(e) => {
                            let optionOpen = safeDeepGetWithType(_state, ['optionOpen'], {});
                            optionOpen[key] = false;
                            _this.setState({ optionOpen: { ...optionOpen } });
                          }} isOpen={safeDeepGetWithType(_state, ['optionOpen', key], false)} style={{ cursor: 'pointer' }}>
                            <DropdownToggle tag="div">
                              <MoreIcon color="inherit" style={{ height: 30, width: 30 }} />
                            </DropdownToggle>
                            <DropdownMenu style={{ padding: 0, margin: 0 }}>
                              <DropdownItem style={{ margin: 0 }} onClick={(e) => { _this.handleEdit(key) }}>
                                <EditIcon color="inherit" style={{ height: 18, width: 18 }} />
                                &emsp;<span style={{ marginRight: 20 }}>Edit</span>
                              </DropdownItem>
                              <DropdownItem style={{ margin: 0 }} onClick={(e) => { _this.handleDelete(key) }}>
                                <DeleteIcon color="inherit" style={{ height: 18, width: 18 }} />
                                &emsp;<span style={{ marginRight: 20 }}>Hapus</span>
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </div>}
              <div className="button-right">
                <Button variant="outlined"
                  type="button"
                  size="large"
                  style={{ minWidth: '0%' }}
                  onClick={(e) => { _this.handleDialogTrigger() }} >Tambah Trigger</Button>
              </div>
            </div>
          }</SizeMe>
          <br />
          <div className="button-right">
            <Button variant="outlined"
              type="button"
              size="large"
              style={{ minWidth: '0%' }}
              onClick={(e) => { _this.handleBack() }} >Kembali</Button>
            <Button variant="contained"
              size="large"
              color="primary"
              type="submit"
              style={{ marginLeft: 10, minWidth: '0%' }}
              onClick={(e) => { _this.handleNext() }} >Lanjut</Button>
          </div>
          <Dialog
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
            open={this.state.dialogOpen}
            aria-labelledby="max-width-dialog-title"
            fullWidth={true}
            maxWidth={'md'}
          >
            <DialogTitle id="form-dialog-title">
              <span>
                <span>Tambah Trigger</span>
              </span>
            </DialogTitle>
            <DialogContent >
              <FormControl required style={{ minWidth: '100%' }} >
                <InputLabel>Field</InputLabel>
                <Select
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  defaultValue={initField}
                  margin='dense'
                  onChange={_this.handleChange}
                  inputProps={{
                    name: 'field'
                  }}
                >
                  <MenuItem value='DEVICE_ID'>Device Id</MenuItem>
                  <MenuItem value='SENSOR'>Sensor</MenuItem>
                  <MenuItem value='CONFIG'>Config</MenuItem>
                  <MenuItem value='PARAM'>Param</MenuItem>
                  <MenuItem value='VALUE'>Value</MenuItem>
                </Select>
              </FormControl>
              <FormControl required style={{ minWidth: '100%' }} >
                <InputLabel>op</InputLabel>
                <Select
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  defaultValue={initOp}
                  margin='dense'
                  onChange={_this.handleChange}
                  inputProps={{
                    name: 'op'
                  }}
                >
                  <MenuItem value='=='>{'=='}</MenuItem>
                  <MenuItem value='>'>{'>'}</MenuItem>
                  <MenuItem value='>='>{'>='}</MenuItem>
                  <MenuItem value='<='>{'<='}</MenuItem>
                  <MenuItem value='<'>{'<'}</MenuItem>
                </Select>
              </FormControl>
              {currentValueType === 'string' &&
                <FormControl required style={{ minWidth: '100%' }} >
                  <TextField
                    label="Value"
                    defaultValue={initValue}
                    onChange={_this.handleChange}
                    type="string"
                    margin='dense'
                    inputProps={{ name: "value" }}
                  />
                </FormControl>
              }
              {currentValueType === 'number' &&
                <FormControl required style={{ minWidth: '100%' }} >
                  <TextField
                    label="Value"
                    defaultValue={initValue}
                    onChange={_this.handleChange}
                    type="number"
                    margin='dense'
                    inputProps={{ name: "value" }}
                  />
                </FormControl>
              }
              <div className="button-right" style={{ marginTop: 20, marginBottom: 20 }}>
                <Button variant="outlined"
                  type="button"
                  size="large"
                  style={{ minWidth: '0%' }}
                  onClick={(e) => { _this.handleCancelDialogTrigger() }}>Cancel</Button>
                <Button variant="contained"
                  size="large"
                  color="primary"
                  type="submit"
                  style={{ marginLeft: 10, minWidth: '0%' }}
                  onClick={(e) => { _this.handleSubmitDialogTrigger() }}>Add</Button>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    info: safeDeepGetWithType(state, ['rule', 'create_info'], {}),
    trigger: safeDeepGetWithType(state, ['rule', 'create_trigger'], {})
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...bindActionCreators(ruleActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RuleCreateTrigger));